import instance from './axiosInstance';

const routerPrefix = '/auto-insights';

export function getAlertInsights(options = {}) {
  return instance.get(`${routerPrefix}/alerts`, options);
}

export function getAutoInsightSettings(options = {}) {
  return instance.get(`${routerPrefix}/settings`, options);
}

export function saveSettings(reqBody, options = {}) {
  return instance.post(`${routerPrefix}/settings`, reqBody, options);
}

export function getUnderperformingAssets(reqBody, options = {}) {
  return instance.post(`${routerPrefix}/brokenassets`, reqBody, options);
}

export function getNewAppVersion(reqBody, options = {}) {
  return instance.post(`${routerPrefix}/newappversion`, reqBody, options);
}
